export const formatValuesToServerData = (values) => ({
  guests_allowed: values.guestsAllowed
})
